import React, {useState, useEffect} from "react";
import {__CROP_IMG_OBJECT, mrbgStore, setImgCrop} from './mrbgRedux';

function MrbgImgFile({formID,name,other,formsSettings,MP_field}){

  const
    [redFld,setRedFld] = useState( mrbgStore.getState().formsSettings[formID]?.redFld ),
    [cropWidth,setCropWidth] = useState(''),
    [cropHeight,setCropHeight] = useState(''),
    [imageWidth,setImageWidth] = useState(''),
    [imageHeight,setImageHeight] = useState(''),
    [topLeft_x,setTopLeft_x] = useState(''),
    [topLeft_y,setTopLeft_y] = useState('');

  function newImg(inputElm){
    var
      myObj= { ...mrbgStore.getState().__CIO },
      imgs = Object.values(inputElm.files).filter(item=>item.type.match('image.*'));
    if( inputElm && inputElm.files && inputElm.files.length && imgs.length ){
      myObj[formID] = {...__CROP_IMG_OBJECT};

      var
        cw = inputElm.getAttribute('data-width'),
        ch = inputElm.getAttribute('data-height');

      for( let i=0; i<inputElm.files.length; i++ )
        if( inputElm.files[i].type.match('image.*') ){
          myObj[formID].imgSrc = myObj[formID].imgSrc.concat( URL.createObjectURL(inputElm.files[i]) )
          myObj[formID].cw     = myObj[formID].cw    .concat( cw );
          myObj[formID].ch     = myObj[formID].ch    .concat( ch );
          myObj[formID].iw     = myObj[formID].iw    .concat( 0 );
          myObj[formID].ih     = myObj[formID].ih    .concat( 0 );
          myObj[formID].tlx    = myObj[formID].tlx   .concat( 0 );
          myObj[formID].tly    = myObj[formID].tly   .concat( 0 );
        }
    }
    else if( Object.hasOwn(myObj,formID) )
      delete myObj[formID];

    mrbgStore.dispatch(setImgCrop(myObj));
  }

  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setRedFld(mrbgStore.getState().formsSettings[formID]?.redFld)
      if( Object.hasOwn(mrbgStore.getState().__CIO,formID) ){
        setCropWidth  ( mrbgStore.getState().__CIO[formID].cw .join(',') )
        setCropHeight ( mrbgStore.getState().__CIO[formID].ch .join(',') )
        setImageWidth ( mrbgStore.getState().__CIO[formID].iw .join(',') )
        setImageHeight( mrbgStore.getState().__CIO[formID].ih .join(',') )
        setTopLeft_x  ( mrbgStore.getState().__CIO[formID].tlx.join(',') )
        setTopLeft_y  ( mrbgStore.getState().__CIO[formID].tly.join(',') )
      }
    })
    return () =>unsubscribe();
  },[]);

  return(
    <>
      <input name={name} className={redFld.includes(name)? MP_field.emptyField: ''} disabled={!other.multiple && formsSettings?.disabled.includes(name)? true:false} type="file" {...other} onChange={e=>newImg(e.target)}/>
      <input name="cropWidth" type="hidden" value={cropWidth}/>
      <input name="cropHeight" type="hidden" value={cropHeight}/>
      <input name="imageWidth" type="hidden" value={imageWidth}/>
      <input name="imageHeight" type="hidden" value={imageHeight}/>
      <input name="topLeft_x" type="hidden" value={topLeft_x}/>
      <input name="topLeft_y" type="hidden" value={topLeft_y}/>
    </>
  )
}

export default MrbgImgFile;